import React, { useState } from "react";
import "./OtherIncome.css";

import CustomSwitch from "../../Components/CustomSwitch/CustomSwitch";

import Checkbox from "@mui/material/Checkbox";
import BackIcon from "../../assets/images/client-dashboard/adddepinfo-banbtnbackicon.svg";
import { useNavigate } from "react-router-dom";
const initialData = [
  {
    id: 1,
    question:
      "Have you earned any interest & dividend income for 2020? If yes please upload 1099-INT & DIV",
    enabled: false,
    explanation: "",
  },
  {
    id: 2,
    question:
      "Did you receive any business income or loss for the year 2020? If yes please upload 1099-MISC",
    enabled: false,
    explanation: "",
  },
  {
    id: 3,
    question:
      "Have you sold any Stocks in 2020 if yes please provide 1099-B document?",
    enabled: false,
    explanation: "",
  },
  {
    id: 4,
    question: "If you sold any ESPP please provide us form 3922?",
    enabled: false,
    explanation: "",
  },
  {
    id: 5,
    question:
      "Do you have any rental Income & incurred any expenses related to that rental property in India or USA?",
    enabled: false,
    explanation: "",
  },
  {
    id: 6,
    question: "Have you earned any interest income in US or abroad (India)",
    enabled: false,
    explanation: "",
  },
  {
    id: 7,
    question:
      "Have you with draw money from HSA? If yes please upload form 1099-SA.",
    enabled: false,
    explanation: "",
  },
  {
    id: 8,
    question:
      "Have you with drawn money from IRA 401k? If yes please enter the amount and form 1099-R",
    enabled: false,
    explanation: "",
  },
  {
    id: 9,
    question:
      "Have you received any refund from states in Tax Year 2020 for the last year (only if return was itemized)?",
    enabled: false,
    explanation: "",
  },
  {
    id: 10,
    question: "Have you received any unemployment compensation 1099G.?",
    enabled: false,
    explanation: "",
  },
  {
    id: 11,
    question:
      "Did you get any income or losses from royalties, partnership, s-corporation & trusts etc. if yes please upload schedule k-1 (form 1065 or form 1120s).",
    enabled: false,
    explanation: "",
  },
  {
    id: 12,
    question:
      "Have you received any third-party payment? If yes please provide form 1099-K.",
    enabled: false,
    explanation: "",
  },
];
const ClientDashboardOtherIncome = () => {
  const [data, setData] = useState(initialData);
  return (
    <div className="clientdashboard__otherincome_section">
      <div className="clientdashboard__otherincome_wrapper">
        <div className="clientdashboard__otherincome_innersection">
          <div className="clientdashboard__otherincome_inrsecheader">
            <div> Other Income Info</div>
          </div>
          <div className="clientdashboard__otherincome_inrsecbody">
            {data.map((item, index) => (
              <>
                <div className="clientdashboard__otherincome_isbitem">
                  <div className="clientdashboard__otherincome_isbileft">
                    {item.question}
                  </div>
                  <div className="clientdashboard__otherincome_isbiright">
                    <span>{item.enabled ? "YES" : "NO"}</span>{" "}
                    <CustomSwitch
                      onSwitch={(enabled) => {
                        setData(
                          data.map((itm, idx) => {
                            if (index === idx) {
                              return { ...itm, enabled };
                            } else {
                              return itm;
                            }
                          })
                        );
                      }}
                    />
                  </div>
                </div>
                {item.enabled && (
                  <textarea
                    className="clientdashboard__otherincome_isbexplain"
                    placeholder="Please Explain"
                  ></textarea>
                )}
              </>
            ))}
          </div>
        </div>
        <div
          className="clientdashboard__depndtinfo_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="clientdashboard__depndtinfo_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="clientdashboard__depndtinfo_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
      </div>

      <br />
      <div className="clientdashboard__otherincome_wrapper">
        <div className="clientdashboard__otherincome_bottombtns">
          <button className="clientdashboard__otherincome_bottombtn1">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardOtherIncome;
